import React from "react";
import Link from "next/link";

import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

//prettier-ignore
function BlogPagination({ total, page, size }) {




  const lastPage = Math.ceil(total / size);
/*
  console.log("total :", total);
  console.log("page :", page);
  console.log("lastPage :", lastPage);
  console.log("size :", size);
*/
 

   page = Number.parseInt(page, 10) || 1;

 // console.log(" paaaage integer  ? ", Number.isInteger(page));
if(page <= 0 || !Number.isInteger(page)) {
  page = 1
 
 }
if (page > lastPage ) {
  page = lastPage

} 




  function paginate( page ,lastPage ) {
    let pagesArray = [];
    
    if (lastPage<= 1) {
      pagesArray = [1];
    } else if (lastPage === 2) {
      pagesArray = [1, 2];
    } else if (lastPage === 3) {
      pagesArray = [1, 2, 3];
    } else if (lastPage > 3 && page < lastPage) {
      if(page == 1) pagesArray = [page , page +1 , page + 2];
      else
      pagesArray = [page - 1, page, page + 1];
    } else if (page >= lastPage) {
      pagesArray = [lastPage- 2, lastPage - 1, lastPage];
    }
  
    return pagesArray;
  }


  const pagesArray = paginate(parseInt(page,10), lastPage);






  /*
  for (let i = 1; i <= lastPage; i++) {
    pagesArray.push(i);
  }
  console.log(pagesArray);
*/
  return (
    <div className="py-10 text-xs">
      <div className=" flex items-center justify-center  ">
        {

 <div className="flex-col">
          {page > 1 && (
            <Link href={`?page=${page - 1}`} diseabled={page ===lastPage ? true : undefined }   className="py-1 px-2 text-backbg" >
              <MdKeyboardArrowLeft className="  w-6 h-6 "/>
            </Link>
          )}
        </div>
}
<div>
          {page > 2 && (
            <Link key={"buttonInfinitLess"} diseabled={page ===lastPage ? true : undefined } href={`?page=${page - 1}`} className="flex items-center justify-centere text-backbg rounded-sm border-[1px] border-gray-400/50 py-2 px-2 mx-1    hover:cursor-pointer transition duration-200" >
         ...
            </Link>
          )}
        </div>


        <div className="gap-2">
          {
             pagesArray.map((num) => {

              if(num > 0)
                return (
                  
                  <Link
                    key={num}
                    href={`?page=${num}`}
                    className={`py-2 px-2 mx-1    hover:cursor-pointer transition duration-200 rounded-sm border-[1px] border-gray-400/50 ${num == page ?  "text-white  bg-backbg  hover:bg-backbg/80 " : "text-backbg bg-white  hover:bg-gray-100 " }`}
                    >
                    {num}
                  </Link>
                );
              })
            }
        </div>

       

        <div>
          {page < lastPage && (
            <Link key={"buttonInfinit"} diseabled={page ===lastPage ? true : undefined } href={`?page=${page + 1}`} className="flex items-center justify-centere text-backbg rounded-sm border-[1px] border-gray-400/50 py-2 px-2 mx-1    hover:cursor-pointer transition duration-200" >
         ...
            </Link>
          )}
        </div>

          
          <div>
          {page < lastPage && (
            <Link diseabled={page ===lastPage ? true : undefined } href={`?page=${page + 1}`} className="py-1 px-2 flex items-center justify-centere text-backbg" >
           <MdKeyboardArrowRight className="  w-6 h-6 "/>
            </Link>
          )}
        </div>
          
      </div>
    </div>
  );
}

export default BlogPagination;
